import { Theme, css } from '@emotion/react';

export const servicePartyCardCssDefs = {
  card: ({ colors, spacing }: Theme) => css`
    background-color: ${colors.bgDefault};
    border-radius: var(--pantry-borderRadius-100);
    color: ${colors.fgDefault};
    overflow: hidden;
    padding: ${spacing(1)}px;
    position: relative;
    width: 100%;
  `,
  content: ({ spacing }: Theme) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing(0.5)}px;
    position: relative;
  `,
  row: ({ spacing }: Theme) => css`
    align-items: baseline;
    display: flex;
    gap: ${spacing(1.5)}px;
    justify-content: space-between;
  `,
  partyName: css`
    display: block;
    overflow: hidden;
    text-decoration: underline;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  partyNameButton: css`
    background: none;
    border: 0;
    color: inherit;
    cursor: pointer;
    min-width: 0;
    overflow: hidden;
    padding: 0;
    text-align: left;
  `,
  trailingText: css`
    flex-shrink: 0;
  `,
};
